/**
 * Ritorna la base URL dell'ambiente corrente per link condivisibili
 * (email magic-link, QR code, clipboard "copia link").
 *
 * - Su `localhost:4200` → `http://localhost:4200` (utile per testare il
 *   flow email durante sviluppo)
 * - Su `collapp.amajorsb.com` → `https://collapp.amajorsb.com`
 * - Su `app.amajorsb.com` → `https://app.amajorsb.com`
 *
 * Per gli endpoint email (es. `/users/LinkAccess`) questo valore va
 * passato nel body come `baseUrl` — il backend Node deve usarlo per
 * costruire il link nell'email invece del suo `process.env.APP_URL`
 * (hardcoded su prod). Se il backend non lo consuma, ricade su prod:
 * comportamento attuale pre-fix. Zero regressione.
 */
export function getShareableBaseUrl(): string {
  return (typeof window !== "undefined" && window.location?.origin) || "";
}
